import React from 'react';
import { List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Meta from '@bizapp-lp/pjr/organisms/Meta';
import {
  MarketoComplexForm,
  MarketoComplexFormProps,
} from '@bizapp-lp/pjr/templates/MarketoComplexForm';

const title =
  'Project Room 資料請求 | 社内外とのプロジェクトを複数同時に進める現場のコラボレーションを支援・促進します';
const description =
  'Project Roomは、プロジェクトのための、簡単・安全に利用できるコミュニケーションツール。社外関係者も含めたプロジェクトメンバー全体のコミュニケーションを活性化し、エンゲージメントを向上します。プロジェクトで取り扱うファイルや予定の共有も一か所に集約でき、情報共有やノウハウ蓄積、共同作業をサポートします。';

export interface DocumentClaimProps
  extends Pick<MarketoComplexFormProps, 'marketoForm'> {
  grecaptchaKey?: string;
}

const DocumentClaim: React.FC<DocumentClaimProps> = ({
  grecaptchaKey,
  marketoForm,
}) => {
  const complexFormProps: MarketoComplexFormProps = {
    title: (
      <>
        <span>Project Room</span>
        <span>資料ダウンロード</span>
      </>
    ),
    subtitle:
      'HUE Works Suite Project Roomにご興味をお持ちいただきありがとうございます。Project Roomの導入検討にお役立ていただける資料をご用意しております。',
    imgSrc: `${process.env.PUBLIC_URL}/images/dlfiles_pjr.png`,
    imgAlt: 'Project Room 資料サムネイル',
    article: (
      <>
        <Typography>以下内容の資料をダウンロードいただけます。</Typography>
        <List component="ul">
          <ListItem>
            <ListItemText>HUE Works Suite Project Room ご紹介資料</ListItemText>
          </ListItem>
        </List>
        <Typography>
          弊社サービスのご紹介資料をご用意しております。ぜひご活用ください。
        </Typography>
      </>
    ),
    children: (
      <>
        <span>下記フォームにご記入ください。</span>
        <span>フォーム送信後、ダウンロード画面へ移動します。</span>
      </>
    ),
    marketoForm: {
      ...marketoForm,
      formName: 'pjr_document_claim',
    },
  };
  return (
    <GoogleReCaptchaProvider reCaptchaKey={grecaptchaKey}>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <MarketoComplexForm {...complexFormProps} />
    </GoogleReCaptchaProvider>
  );
};

export default DocumentClaim;
